import {configuration} from '../../configuration'
import Storage from '../helpers/storage'

let DB = {}

export default {

    init() {

        const lang = Storage.getItem('lang') || 'en'

        const request = indexedDB.open(configuration.indexedDb.name, configuration.indexedDb.version)

        request.onupgradeneeded = function () {

            DB = request.result

            const store = DB.createObjectStore(configuration.indexedDb.name, {keyPath: 'id'})
            store.add({
                id: 'lang',
                lang: lang
            })
        }

        request.onsuccess = function () {
            DB = request.result
        }

    },


    saveLang(lang) {

        const language = lang || Storage.getItem('lang') || 'en'

        if (DB.transaction) {

            const store = DB.transaction([configuration.indexedDb.name], 'readwrite').objectStore(configuration.indexedDb.name)

            store.put({
                id: 'lang',
                lang: language
            })

        }
    }
}
